// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionWrapper_root__YcQWP"};